import { useTranslation } from "react-i18next";

import { DMS_CAPABILITIES } from "models";
import { convertPascalCaseToSnakeCase, convertPascalCaseToText } from "utils/common";

const capabilityNameMap = Object.entries(DMS_CAPABILITIES).reduce<Record<number, string>>((names, [key, value]) => {
  if (typeof value === "number") names[value] = key;

  return names;
}, {});

type CapabilityLabelProps = {
  dmsCapabilityId: DMS_CAPABILITIES | null;
};

export const CapabilityLabel = ({ dmsCapabilityId }: CapabilityLabelProps) => {
  const { t } = useTranslation();

  const capabilityName = dmsCapabilityId ? capabilityNameMap[dmsCapabilityId] : null;
  if (!capabilityName) return null;

  return t(`v8_${convertPascalCaseToSnakeCase(capabilityName)}`, convertPascalCaseToText(capabilityName));
};
